import React from "react";

import IconButton from "@material-ui/core/IconButton";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import Tooltip from "@material-ui/core/Tooltip";

const LlmChatButton = ({showLlmChat, toggleLlmChat}) => {
  return (
    <Tooltip title={"Q&A with a LLM model about the contract"}>
      <IconButton
        style={showLlmChat ? {backgroundColor: "#aaa"} : {}}
        onClick={() => toggleLlmChat()}
      >
        <QuestionAnswerIcon />
      </IconButton>
    </Tooltip>
  );
};

export default LlmChatButton;
